<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="dashboard-analytics">
        
      <div class="vx-row" v-if="dataNotLoading">
        <div class="vx-col w-full">
          <vs-input icon-pack="feather" icon="icon-search" placeholder="Nome da empresa" v-model="search" class="is-label-placeholder mb-base" />

        </div>
        <div v-for="company in filtered "  :key="company.id" class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base">
                <vx-card class="p-2">
                    <div class="text-center">
                        <h5>{{ company.name }}</h5>
                        <p class="text-grey">{{ company.address }}</p>
                    </div>
                    <vs-avatar class="mx-auto my-6 block" size="80px" :src="company.image" />
                    <div class="flex justify-between text-center">
                        <span>
                            <p class="text-md font-semibold">Estado</p>
                            <small class="text-grey font-semibold">
                                <span v-if="company.status==1" style="display: flex;">
                                    <div class="h-2 w-2 rounded-full mr-1" :class="'bg-success'"></div>
                                      
                                    Activa </span>
                                <span v-if="company.status==0">
                                    <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                                    Desactiva</span>
                            </small>
                        </span>
                        <span>
                            <p class="text-md font-semibold">Funcionários</p>
                            <small class="text-grey font-semibold">{{ company.total_employees }}</small>
                        </span>
                        <span>
                            <p class="text-md font-semibold">Telefone</p>
                            <small class="text-grey font-semibold">{{ company.phone }}</small>
                        </span>
                    </div>
                    <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC"  :to="{
                name: 'company-proflie',
                params: { companyId: company.id },
              }">Ver empresa</vs-button>
                </vx-card>
            </div>
      </div>
      <div v-else style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    </div>
  </template>
  
  <script>
 import http from '../../../../../http-common';
  export default {
    data() {
    return {
      dataNotLoading: false,
        companies:[],
        search:"",
     }
    },

    mounted() {
    this.getCompanies();
    
  },


  computed: {
    filtered() {
      return this.companies.filter((e) =>
        e.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },

  methods: {
    getCompanies() {
    this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        
          
      };
      
      http
        .get("/admin/companies", config)
        .then((result) => {
            
           this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      this.companies = result.data
      this.dataNotLoading = true

        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },
  }
  }
  </script>
  
  <style lang="scss">
  /*! rtl:begin:ignore */
  #dashboard-analytics {
    .greet-user{
      position: relative;
  
      .decore-left{
        position: absolute;
        left:0;
        top: 0;
      }
      .decore-right{
        position: absolute;
        right:0;
        top: 0;
      }
    }
  
    @media(max-width: 576px) {
      .decore-left, .decore-right{
        width: 140px;
      }
    }
  }
  /*! rtl:end:ignore */
  </style>
  